export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const SET_USER_REGISTER = "SET_USER_REGISTER";
export const SET_USER_LOG_OUT = "SET_USER_LOG_OUT";
export const UPDATE_USER_INFOR = "UPDATE_USER_INFOR";
export const SET_USER_INFOR = "SET_USER_INFOR";
